<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="red lighten-2" append to="PUV">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs7>
                <div class="headline">PUV</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="main-data">
                  <color-indicator :formated-value="indicateurPromotion('Toutes', 'PUV')" 
                    :raw-value="indicateurPromotion('Toutes', 'PUV') - indicateurPromotion('Toutes', 'objectifsPUV')">
                  </color-indicator>
                </div>
                <div>/ {{ indicateurPromotion('Toutes', 'objectifsPUV') }}</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="indigo lighten-2" append to="PC">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs7>
                <div class="headline">Dépôt PC</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="main-data">
                  <color-indicator :formated-value="indicateurPromotion('Toutes', 'PC')" 
                    :raw-value="indicateurPromotion('Toutes', 'PC') - indicateurPromotion('Toutes', 'objectifsPC')">
                  </color-indicator>
                </div>
                <div>/ {{ indicateurPromotion('Toutes', 'objectifsPC') }}</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="teal lighten-2" append to="com">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs7>
                <div class="headline">Ouverture com.</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="main-data">
                  <color-indicator :formated-value="indicateurPromotion('Toutes', 'com')" 
                    :raw-value="indicateurPromotion('Toutes', 'com') - indicateurPromotion('Toutes', 'objectifsCom')">
                  </color-indicator>
                </div>
                <div>/ {{ indicateurPromotion('Toutes', 'objectifsCom') }}</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="blue darken-1" append to="achat">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs7>
                <div class="headline">Achat</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="main-data">
                  <color-indicator :formated-value="indicateurPromotion('Toutes', 'achat')" 
                    :raw-value="indicateurPromotion('Toutes', 'achat') - indicateurPromotion('Toutes', 'objectifsAchat')">
                  </color-indicator>
                </div>
                <div>/ {{ indicateurPromotion('Toutes', 'objectifsAchat') }}</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="orange lighten-2" append to="demarrage">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs7>
                <div class="headline">Démarrage</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="main-data">
                  <color-indicator :formated-value="indicateurPromotion('Toutes', 'demarrage')" 
                    :raw-value="indicateurPromotion('Toutes', 'demarrage') - indicateurPromotion('Toutes', 'objectifsDemarrage')">
                  </color-indicator>
                </div>
                <div>/ {{ indicateurPromotion('Toutes', 'objectifsDemarrage') }}</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card ripple hover class="border-left" color="green" append to="livraison">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs7>
                <div class="headline">Livraison</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="main-data">
                  <color-indicator :formated-value="indicateurPromotion('Toutes', 'livraison')" 
                    :raw-value="indicateurPromotion('Toutes', 'livraison') - indicateurPromotion('Toutes', 'objectifsLivraison')">
                  </color-indicator>
                </div>
                <div>/ {{ indicateurPromotion('Toutes', 'objectifsLivraison') }}</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
  name: 'Promotion',
  data(){
    return {
     
    }
  },
  computed: {
    ...mapGetters([
      'indicateurPromotion'
    ])
  }
}
</script>

<style scoped>

</style>
